import React from 'react';
import List from '../../../Components/Global/Lists';

export const Footer_Text = [
  {
    textSize: '1.25rem',
    textMobile: '0.625rem',
    renderContent: () => (
      <span>© 2026 KUTER S.A.P.I. de C.V. All rights reserved.</span>
    ),
  },
];

export const Legal_Title = [
  {
    textSize: '1.5rem',
    marginBottom: '0.563rem',
    textMobile: '0.75rem',
    renderContent: () => <span>LEGAL & POLICIES</span>,
  },
];

export const Legal_List = [
  {
    text: 'PRIVACY POLICY',
    dataTarget: 'legal-notice',
    click: true,
  },
  {
    text: 'PRIVACY NOTICE',
    dataTarget: 'privacy-notice',
    click: true,
  },
  {
    text: 'LEGAL NOTICE',
    dataTarget: 'privacy-policies',
    click: true,
  },
];

export const Warning = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    fontWeight: '400',
    lineHeight: '1.4',
    textMobile: '0.75rem',
    renderContent: () => (
      <span>
        For the entire community:
        <br />
        <br />
        We’ve been made aware of multiple casting calls circulating under the
        name KUTER Casa Productora, using phone numbers and platforms such as
        Facebook and WhatsApp that do not belong to our team.
        <br />
        <br />
        We want to make it absolutely clear that these casting calls are
        completely FALSE. No member of our team will ever request nude or
        underwear photos through any channel, and we do not conduct castings via
        video call.
        <br />
        <br />
        All official castings are published exclusively through our verified
        channels on Facebook and Instagram. We also work with industry-certified
        casting agencies.
        <br />
        <br />
        We kindly ask you to report these posts and to always verify information
        through official production company channels. Please help us by sharing
        this message so no one becomes a victim of these situations.
      </span>
    ),
  },
];

export const Legal_Notice = [
  {
    textSize: '1.75rem',
    marginBottom: '0px',
    fontWeight: '400',
    lineHeight: '1.3',
    textMobile: '0.75rem',
    renderContent: () => (
      <span>
        LEGAL NOTICE
        <br />
        <br />
        The credits indicated, as well as the works, content, and audiovisual
        material displayed on this website, are for informational purposes only,
        with the aim of showcasing the creations of KUTER Casa Productora. All
        Intellectual Property rights arising from such works belong to the
        Client.
        <br />
        <br />
        The full or partial use or reproduction of the content displayed on this
        website is strictly prohibited without the prior written consent of
        McGuffin Casa Productora S.A. de C.V., Largometrajes S.A. de C.V. and/or
        KUTER S.A.P.I. de C.V., as well as the Client or Brand for whom the
        Production was developed.
        <br />
        <br />
        All Productions displayed on this website belong to the Brand and/or the
        requesting party, and were created under consultation or commissioned,
        in whole or in part, by associates or employees of McGuffin Casa
        Productora S.A. de C.V., Largometrajes S.A. de C.V. and/or KUTER
        S.A.P.I. de C.V.
        <br />
        <br />
        For further information, please contact personnel of McGuffin Casa
        Productora S.A. de C.V., Largometrajes S.A. de C.V. and/or KUTER
        S.A.P.I. de C.V. through the corresponding section of this website.
      </span>
    ),
  },
];

export const Privacy_Notice = [
  {
    textSize: '1.875rem',
    marginBottom: '0px',
    fontWeight: '400',
    lineHeight: '1.3',
    textMobile: '0.75rem',
    textType: 'div',
    renderContent: () => (
      <span>
        PRIVACY NOTICE
        <br />
        Privacy Notice for Clients of KUTER Casa Productora
        <br />
        <br />
        I.- Identity and Address of the Data Controller. In accordance with the
        provisions of the Federal Law on the Protection of Personal Data Held by
        Private Parties (hereinafter referred to as the “Law”), as well as its
        Regulations, we hereby inform you that McGuffin Casa Productora S.A. de
        C.V., KUTER S.A.P.I. de C.V. and/or Largometrajes S.A. de C.V.
        (hereinafter referred to as KUTER Casa Productora), (the “Data
        Controller”), with registered address at Zamora 169, interior 2, Col.
        Condesa, Cuauhtémoc Borough, C.P. 06140, Mexico City, (the “Contact
        Address”), will process the personal data collected from you, under the
        terms set forth in this Privacy Notice.
        <br />
        <br />
        II.- Purposes of Processing the Personal Data Collected.
        <br />
        <br />
        The processing of the collected data will be carried out for the
        following purposes:
        <br />
        <br />
        A: Purposes Necessary for the Legal Relationship with the Data
        Controller.
        <List
          textSize={'1.875rem'}
          textTransform={'none'}
          marginBottom={'0px'}
          textMobile={'0.75rem'}
          dataList={ListPrivacy}
        />
        <br />
        <br />
        B: Others
        <List
          textSize={'1.875rem'}
          textTransform={'none'}
          marginBottom={'0px'}
          textMobile={'0.75rem'}
          dataList={ListPrivacy2}
        />
        <br />
        <br />
        Therefore, and in order to fulfill the purposes stated above, the
        following personal data will be processed: first name(s), last name(s),
        address, telephone number (mobile and landline), RFC (Mexican Tax ID),
        property records, employer registration with the IMSS, nationality,
        country of residence, type of service required, contact name, contact
        telephone number, contact email address, service reports, sector,
        business line, and the following financial or patrimonial data: main
        credit institutions in which you hold bank accounts, branch offices,
        account numbers, and bank account numbers.
        <br />
        <br />
        III.- Options and Means to Limit the Use or Disclosure of Your Data. You
        may contact the Data Controller’s Human Resources Department to submit a
        request to limit the use or disclosure of your personal data, in
        accordance with the provisions set forth in this Privacy Notice.
        <br />
        <br />
        IV.- Means to Exercise the Rights of Access, Rectification,
        Cancellation, or Objection (the “ARCO Rights”).
        <br />
        <br />
        You have the right to: (I)access your personal data held by us and know
        the details of how it is processed, (II) rectify it if it is inaccurate
        or incomplete, (iii) cancel it when you consider it is not required for
        any of the purposes stated in this Privacy Notice, is being used for
        non-consented purposes, or when the contractual or service relationship
        has ended, or (iv) object to its processing for specific purposes, as
        established by the Law.
        <br />
        <br />
        To exercise your ARCO Rights, you must submit a request (the “ARCO
        Request”) to the Data Controller, addressed to the Human Resources
        Department, to the Contact Address and/or to the email address
        productora@kuter.com.mx, including the following information and
        documentation:
        <br />
        <br />
        <List
          textSize={'1.875rem'}
          textTransform={'none'}
          marginBottom={'0px'}
          textMobile={'0.75rem'}
          dataList={ListPrivacy3}
        />
        <br />
        <br />© 2026 KUTER S.A.P.I. de C.V. Todos los derechos reservados.
      </span>
    ),
  },
];

const ListPrivacy = [
  {
    text: 'To generate a customer database.',
  },
  {
    text: 'To improve the control and execution of subsequent inquiry processes.',
  },
  {
    text: 'To properly provide the service.',
  },
  {
    text: 'To enter into an agreement for the Data Controller to provide its services, such as recruitment and selection, payroll administration, among others.',
  },
];

const ListPrivacy2 = [
  {
    text: 'To carry out transfers of data with third parties, in accordance with the provisions set forth in this Privacy Notice, as applicable.',
  },
];

const ListPrivacy3 = [
  {
    text: 'Name and address of the data subject, or any other means by which we may contact them in order to respond to their request.',
  },
  {
    text: 'Documents that prove your identity (INE, passport, professional license, or any official identification), or, as applicable, the legal representation of the data subject. Such documents must be presented in original at the Contact Address in order to receive the Data Controller’s response.',
  },
  {
    text: 'A clear and precise description of the personal data with respect to which you seek to exercise any of the rights, as well as which specific right you wish to exercise.',
  },
];

export const Privacy_Policies = [
  {
    textSize: '1.875rem',
    marginBottom: '0px',
    fontWeight: '400',
    lineHeight: '1.35',
    textMobile: '0.75rem',
    renderContent: () => (
      <span>
        PRIVACY POLICY
        <br />
        <br />
        KUTER Casa Productora (McGuffin Casa Productora S.A. de C.V.,
        Largometrajes S.A. de C.V. and/or KUTER S.A.P.I. de C.V.) has always
        been committed to maintaining the accuracy, confidentiality, and
        security of your personal and corporate information. We have established
        privacy principles to govern our use of customer information. KUTER Casa
        Productora (McGuffin Casa Productora S.A. de C.V., Largometrajes S.A. de
        C.V. and/or KUTER S.A.P.I. de C.V.) does not sell, share, or distribute
        customer information to any third-party organization.
        <br />
        <br />
        Accountability
        <br />
        <br />
        KUTER Casa Productora (McGuffin Casa Productora S.A. de C.V.,
        Largometrajes S.A. de C.V. and/or KUTER S.A.P.I. de C.V.) is responsible
        for maintaining and protecting customer information under its control.
        <br />
        <br />
        Identifying Purposes
        <br />
        <br />
        The purpose for which customer information is collected will be
        identified by KUTER Casa Productora before or at the time the
        information is collected.
        <br />
        <br />
        Consent
        <br />
        <br />
        The knowledge and consent of the customer are required for the
        collection, use, or disclosure of their information, except where
        required or permitted by law.
        <br />
        <br />
        Limiting Collection
        <br />
        <br />
        The customer information collected must be limited to the details
        necessary for the purposes identified by KUTER Casa Productora (McGuffin
        Casa Productora S.A. de C.V., Largometrajes S.A. de C.V. and/or KUTER
        S.A.P.I. de C.V.). Information must be collected by fair and lawful
        means.
        <br />
        <br />
        Limiting Use, Disclosure, and Retention
        <br />
        <br />
        Customer information may only be used or disclosed for the purpose for
        which it was collected, unless the customer has consented otherwise, or
        where its use is required or permitted by law. Customer information may
        only be retained for the period of time necessary to fulfill the purpose
        for which it was collected.
        <br />
        <br />
        Accuracy
        <br />
        <br />
        Customer information must be maintained as accurate, complete, and up to
        date as is necessary to fulfill the purposes for which it is required.
        <br />
        <br />
        Safeguarding Customer Information
        <br />
        <br />
        Customer information must be protected by security safeguards
        appropriate to the sensitivity level of the information.
        <br />
        <br />
        Accessibility
        <br />
        <br />
        KUTER Casa Productora (McGuffin Casa Productora S.A. de C.V.,
        Largometrajes S.A. de C.V. and/or KUTER S.A.P.I. de C.V.) recognizes and
        respects that all persons, including those in vulnerable situations,
        must be able to independently exercise their human rights of access to
        information and protection of personal data on equal terms with others.
        This shall not be hindered by the physical environment, information,
        communications, including systems and information technologies,
        telecommunications, or other services and facilities open to the public
        or for general use, both in urban and rural areas.
        <br />
        <br />
        Disclosure of Customer Information
        <br />
        <br />
        Upon request, the customer will be informed of the existence of their
        information and will be granted access to it. Likewise, customers will
        be informed of the use and disclosure of their information and will be
        granted access to it. Customers may verify the accuracy and completeness
        of their information and may request its correction, updating, or
        modification, as applicable.
        <br />
        <br />
        Handling Complaints and Suggestions
        <br />
        <br />
        Customers may direct any questions or inquiries regarding the privacy
        principles described above, or about our practices, by contacting the
        designated person responsible for privacy at KUTER Casa Productora
        (McGuffin Casa Productora S.A. de C.V., Largometrajes S.A. de C.V.
        and/or KUTER S.A.P.I. de C.V.).
        <br />
        <br />
        Opt-Out
        <br />
        <br />
        If you wish to unsubscribe, please send an email to
        productora@kuter.com.mx, send written correspondence to Zamora 169
        interior 2, Colonia Condesa, Cuauhtémoc Borough, C.P. 06140, Mexico
        City, or call us at +52 55-6842-5431.
      </span>
    ),
  },
];
